import React, {useState} from 'react';

import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DesktopDatePicker, StaticDatePicker } from '@mui/x-date-pickers-pro';



export default function BasicDatePicker(props) {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StaticDatePicker
        // label="Date"
        dialog={false}
        showToolbar={false}
        value={props.selected}
        disablePast
        components={{
          ActionBar: () => <></>,
        }}
        onChange={props.onChange}
        shouldDisableDate={props.shouldDisableDate}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
}